export const potvrda_o_preuzimanju_radnopravne_dokumentacije = { 
    templateId: 36, 
    category: 3,
    templateTitle: "Potvrda o preuzimanju radnopravne dokumentacije",
    templateDescription: `<p>Poslodavac je dužan u roku od petnaest dana od dana prestanka radnog odnosa​ radniku vratiti sve njegove isprave te primjerak odjava s obveznoga mirovinskog i zdravstvenog osiguranja i izdati mu potvrdu o vrsti poslova koje je obavljao i trajanju radnog odnosa, a budući da poslodavac po potrebi mora dokazati da je navedeno i učinio, predlaže da se radnik u tu svrhu potpiše potvrdu o preuzimanju navedene dokumentacije.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Poslodavac je dužan u roku od <strong>petnaest dana od dana prestanka radnog odnosa</strong>​ vratiti radniku sve njegove isprave i primjerak odjave s obveznoga mirovinskog i zdravstvenog osiguranja te mu izdati potvrdu o vrsti poslova koje je obavljao i trajanju radnog odnosa.</p>
    <p>Radi sveobuhvatnog dostavljanja navedene dokumentacije te olakšavanja dokazivanja poslodavca da je postupio sukladno Zakonu o radu, predlaže se izdavanje potvrde prema primjeru u nastavku.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Poslovni subjekt',
                label: 'Poslovni subjekt',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija",
                    inSignature: true,
                }],
                suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: '​izdaje sljedeću',
    title: 'POTVRDU O PREUZIMANJU RADNOPRAVNE DOKUMENTACIJE',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Radnik'},
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz',},
                        { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},
                        {type: 'text', content: ', (u nastavku teksta: Radnik), bio je zaposlen kod Poslodavca do dana'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godine.'}],
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Radnik potvrđuje da mu je Poslodavac s danom potpisa ove Potvrde predao sljedeću radnopravnu dokumentaciju:\r\n',
                },
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: '- odjava s HZZO-a,\r\n- odjava s HZMO-a,\r\n- poreznu karticu, \r\n- Potvrda o vrsti poslova koje je radnik obavljao i trajanju radnog odnosa.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
                help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
              }
            ]
          },
          {
            static: true,
            mandatory: true,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
                content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
              },
            ]
          },
        ],
      };



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/36_potvrda_o_preuzimanju_radnopravne_dokumentacije.ts